module.exports = __webpack_public_path__ + "static/media/menu.8cf2f9ce.svg";